import './styles/mobile-nav.css'
import logo from '../assets/icons/logo2.svg'
import { Link } from 'react-router-dom'

export default function MobileNav({handler,isVisible}) {
    if(!isVisible){
        return <></>
    }

  return (
    <nav onClick={handler} id='modal-toggle' className='nav-mobile'>
        <div className='nav-mobile__body'>
            <div className='nav-mobile__logo'>
                <Link to={'/'}>
                    <img src={logo} alt="logo" />
                </Link>
            </div>
            <div className='nav-mobile__btns'>
                <div className='nav-mobile__item-sign-btn'>
                    <a href="/">Sign in</a>
                </div>
                <div className='nav-mobile__item-start-btn'>
                    <a href="/">Get started</a>
                </div>
            </div>
            <div className='nav-mobile__items'>
                <div className='nav-mobile__item'>
                    <a id='modal-toggle' href="#home">Home</a>
                </div>
                <div className='nav-mobile__item three'>
                    <a id='modal-toggle' href="#extension">Extension</a>
                </div>
                <div className='nav-mobile__item four'>
                    <a id='modal-toggle' href="#pricing">Pricing</a>
                </div>
                <div className='nav-mobile__item'>
                    <a id='modal-toggle' href="#blog">Resume Review</a>
                </div>
                <div className='nav-mobile__item two'>
                    <a id='modal-toggle' href="#features">Features</a>
                </div>
                <div className='nav-mobile__item'>
                    <a id='modal-toggle' href="#contact-us">Contact</a>
                </div>
            </div>
        </div>
    </nav>
  )
}
